module.exports = __webpack_public_path__ + "static/img/34.8bc7154d.png";